module.exports = __webpack_public_path__ + "static/media/doc1.0c42e217.svg";